'use client';

import { selectEnv } from 'common-nextjs';
import { useSearchParams } from 'next/navigation';
import Script from 'next/script';
import { useEffect } from 'react';
import FacebookPixel from '~/components/ThirdPartyScripts/FacebookPixel';
import { AnalyticsSource } from '~/services/analytics/AnalyticsInterfaces';
import {
  visitedItem,
  visitedUnknownItem,
} from '~/services/analytics/events/item';
import firePaypalEvent from '~/services/analytics/firePaypalEvent';
import { RailsItem } from '~/typings/services/rails/item';

function addIdToLocalStorage(id: number) {
  try {
    const recentlyViewed = localStorage.getItem('recently_viewed');
    if (recentlyViewed) {
      const array: number[] = JSON.parse(recentlyViewed);
      const foundIndex = array.indexOf(id);

      if (foundIndex >= 0) {
        array.splice(foundIndex, 1);
        array.unshift(id);
      } else if (array.length === 24) {
        array.pop();
        array.unshift(id);
      } else {
        array.unshift(id);
      }

      localStorage.setItem('recently_viewed', JSON.stringify(array));
    } else {
      localStorage.setItem('recently_viewed', JSON.stringify([id]));
    }
  } catch (e) {}
}

export default function AppDirItemDetailsPageAnalyticsClient({
  item,
  paypal,
  username,
}: {
  item: RailsItem;
  paypal?: boolean;
  username?: string;
}) {
  const params = useSearchParams();

  useEffect(() => {
    addIdToLocalStorage(item.id);

    visitedItem({
      item,
      username,
      src: params?.get('src') as AnalyticsSource | undefined,
    });
  }, [item.id]);

  useEffect(() => {
    if (paypal) {
      firePaypalEvent({
        event: 'userIdentification',
        identified: true,
      });
    }
  }, [paypal]);

  return (
    <>
      <FacebookPixel />

      {paypal && (
        <Script
          id="paypal"
          key="paypal"
          dangerouslySetInnerHTML={{
            __html: `
; (function (a, t, o, m, s) { a[m] = a[m] || [];
a[m].push({ t: new Date().getTime(), event:
'snippetRun' }); var f =
t.getElementsByTagName(o)[0], e =
t.createElement(o), d = m !== 'paypalDDL' ? '&m=' +
m : ''; e.async = !0; e.src =
'https://www.paypal.com/tagmanager/pptm.js?t=xo&id=' + s + d; f.parentNode.insertBefore(e, f);
})(window, document, 'script', 'paypalDDL',
'${selectEnv('sidelineswap.com', 'staging.sidelineswap.com')}');`,
          }}
        />
      )}
    </>
  );
}

export function AppDirItemDetailsPageUnknownItemAnalytics({
  itemId,
}: {
  itemId: number | string;
}) {
  useEffect(() => {
    visitedUnknownItem(Number(itemId));
  }, [itemId]);

  return null;
}
